import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ variant = "light", testidPrefix = "home" }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const dark = variant === "dark";

  const submit = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      toast.success("You're on the list. Talk soon.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p data-testid={`${testidPrefix}-newsletter-success`} className={`text-sm ${dark ? "text-gold" : "text-terracotta"}`}>
        Thank you — you're at the table.
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-md flex-col gap-3 sm:flex-row" data-testid={`${testidPrefix}-newsletter-form`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testidPrefix}-newsletter-input`}
        className={`w-full flex-1 rounded-full border px-5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold/70 ${
          dark ? "border-cream/25 bg-cream/10 text-cream placeholder:text-cream/40" : "border-forest/20 bg-white/60 text-ink placeholder:text-ink/40"
        }`}
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testidPrefix}-newsletter-submit`}
        className="cursor-pointer rounded-full bg-terracotta px-7 py-3 text-sm font-medium tracking-wide text-cream transition-[background-color,color] duration-300 hover:bg-gold hover:text-deepforest disabled:opacity-60"
      >
        {busy ? "Joining…" : "Join"}
      </button>
    </form>
  );
}
